import $ from "jquery";

export default class Form {

  constructor() {
    this.form = document.getElementsByClassName('js-material-form');
    this.inputFields = '';
    this.currentForm = '';
    this.proceed = true;

    this.init();
  }

  /**
   * Initialize for each Form
   */
  init() {
    for (let form of this.form) {
      if (form.classList.contains('ajax-form')) {
        this.ajaxSubmit(form);
        this.currentForm = form;
      }

      this.inputFields = form.querySelectorAll('input');

      if (!this.inputFields || '' === this.inputFields) {
        continue;
      }

      for (let input of this.inputFields) {
        input.addEventListener("focus", this.onFocus.bind(this), true);
        input.addEventListener("blur", this.onBlur.bind(this), true);

        // Onload
        this.onValidate(input);
      }
    }
  }

  validateExceptions(input) {
    switch(input.type) {
      default:
        return false;
        case 'file':
      case 'date':
        return true;
    }
  }

  // Validate input fields
  onValidate(input) {

    if(!input) {
      return;
    }

    let parent = input.parentNode;

    if (!this.validateExceptions(input) && parent.classList.contains('is-focus') && !input.value.trim()) {
      parent.classList.remove('is-focus');
    }

    if (parent.classList.contains('is-invalid')) {
      parent.classList.remove('is-invalid');
    }

    if (!input.value) {
      parent.classList.remove('is-valid');
      return;
    }

    // Password Check
    if(input.hasAttribute('id') && input.getAttribute('id').includes("new_password")) {

      if('new_password' === input.getAttribute('id')) {
        document.getElementById('new_password_2').blur();
      }

      if('new_password_2' === input.getAttribute('id')) {
        document.getElementById('new_password').blur();
      }

      this.ajaxOnBlurValidate(input);

      if(false === this.proceed) {
        parent.classList.remove('is-valid');
        parent.classList.add('is-invalid');
      } else if (input.checkValidity()) {
        // use Pattern HTML attribute
        parent.classList.add('is-valid');
      }
    } else {

      if (input.checkValidity()) {
        // use Pattern HTML attribute
        parent.classList.add('is-valid');
      } else {
        parent.classList.remove('is-valid');
        parent.classList.add('is-invalid');
      }
    }
  }

  // Add action onFocus
  onFocus(event) {
    event.target.parentNode.classList.add('is-focus');
  }

  // Add action onBlur
  onBlur(event) {
    this.onValidate(event.target);
  }

  /**
   * Parse data to Object
   * @param entries
   * @returns {{}}
   */
  static paramsToObject(entries) {
    let result = {}
    for (let entry of entries) {
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  }

  /**
   * Convers Query parameters to object
   * @param data
   * @returns {URLSearchParams}
   */
  static convertQueryParams(data = {}) {
    const params = new URLSearchParams();
    Object.keys(data).forEach((dataItem) => {
      params.append(dataItem, data[dataItem]);
    });
    return params;
  }

  ajaxOnBlurValidate(currentInput) {

    let ajaxData = {
      'action': 'checkPassword'
    };

    let formData = new FormData(this.currentForm),
      loader = this.currentForm.querySelector('.loader'),
      button = this.currentForm.querySelector('[type="submit"]');

    loader.classList.add('is-active');
    button.disabled = true;

    let self = this;

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: ajax_object.ajax_url,
      data: Form.convertQueryParams({...ajaxData, ...Form.paramsToObject(formData)}),
      contentType: false,
      processData: false,
      cache: false,
      success: function (response) {
        loader.classList.remove('is-active');

        let messageElement = currentInput.parentNode.querySelector('.error-message');

        if(messageElement && response.data.message) {
          messageElement.innerText = response.data.message;
        }

        button.disabled = false;
        self.proceed = response.success;
      }
    });
  }

  /**
   * Form submit with Ajax
   * @param form
   */
  ajaxSubmit(form) {
    let button = form.querySelector('[type="submit"]');

    button.onclick = function (e) {
      e.preventDefault();

      // Set action and input values
      let formId = form.getAttribute('id'),
        ajaxData = {
          'action': formId
        };

      let formData = new FormData(form);



      if('updateUserAvatar' === formId ||
        'updateOrganisationAvatar' === formId
      ) {
          let files_data = $(form).find('[type="file"]'); // The <input type="file" /> field

          // Loop through each data and create an array file[] containing our files data.
          $.each($(files_data), function(i, obj) {
            $.each(obj.files,function(j,file){
              formData.append('files[' + j + ']', file);
            })
          });

        // our AJAX identifier
        formData.append('action', formId);
        formData.append('user_id', $(form).find('[name="avatar_user_id"]').val());

        if('updateOrganisationAvatar' === formId) {
          formData.append('post_id', $(form).find('[name="avatar_post_id"]').val());
          formData.append('organisationCode', $(form).find('[name="avatar_organisationCode"]').val());
        }
      } else {
        formData = Form.convertQueryParams({...ajaxData, ...Form.paramsToObject(formData)})
      }

      let loader = form.querySelector('.loader');
      loader.classList.add('is-active');
      button.disabled = true;

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajax_url,
        data: formData,
        contentType: false,
        processData: false,
        cache: false,

        success: function (response) {

          if (!response) {
            return;
          }

          // update field value
          let alert = response.data.html;

          if(alert) {
            form.insertAdjacentHTML('beforebegin', alert);

            window.setTimeout(function() {
              form.previousElementSibling.classList.remove('fadeInUp');
              form.previousElementSibling.classList.add('fadeOutUp');
            }, 3000);
          }

          if(response.data.imageSrc) {
            document.getElementById('avatar').src = response.data.imageSrc[0];
          }

          button.disabled = false;
          loader.classList.remove('is-active');
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('Error: ', jqXHR, textStatus, errorThrown);
        }
      });

      // Otherwise form will be submitted the default way.
      return false;
    };
  }
}
